import React, {Fragment, useEffect, useReducer, useRef, useState} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {addUsersToTeam, getTeamDetails} from "root/DataFunctions/TeamDataFns";
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownTeamMembers from "root/ReactHookForm/ui/DropdownTeamMembers";
import {ModalSaveButton, ModalCancelButton} from '../buttons';

const ModalAddTeamMember = ({team_id, filter, onSaveCompleted, onClose, width}) =>
{
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [teamData, setTeamData] = useState({isLoading: true, data: []});

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                team: {
                    team_name: '',
                    team_members: []
                }
            }
        });

    useEffect(() =>
    {
        getTeamDetails(team_id, (response) =>
        {
            const teamData = getDataFromResponse(response)[0];

            setValue('team', {
                    team_name: teamData.team_name,
                    team_members: [],
                }
            );

            setTeamData({isLoading: false, data: teamData});
        });

    }, []);

    const onSaveComplete = () =>
    {
        onSaveCompleted('saved');
        onClose();
    }

    const onClickCancel = () =>
    {
        onSaveCompleted('cancel');
        onClose();
    }

    const disableButtons = () =>
    {
        setButtonDisabled(true);
    }

    const onSubmit = (formData) =>
    {
        disableButtons();

        addUsersToTeam(team_id, formData, onSaveComplete);
    }

    const onClickSaveForm = (status) =>
    {
        disableButtons();
        handleSubmit(onSubmit)(status);
    }

    const validateDropdown = (val) =>
    {
        if (+(val.value) === 0)
        {
            return "You must select a user";
        }
    }

    const formContent = () =>
    {
        return (
            <Fragment>
                <form width={width}>
                    <div className='row'>
                        <div className="col-md-12">
                            <label>Team Name</label>
                            <input readOnly={true} className='form-control' name='team.team_name'
                                   id='team_name' {...register("team.team_name")} />
                            {formErrors.team?.team_name && <ErrorDiv>Please enter a team name</ErrorDiv>}
                        </div>

                        <div className="col-md-12">
                            <label>Select Members</label>
                            <DropdownTeamMembers readOnly={false} control={control}
                                                 name='team.team_members'
                                                 rules={{required: true, validate: validateDropdown}}
                                                 organisation_id='current'
                                                 team_id={team_id}
                                                 filter={filter}
                                                 placeholder='Please select members'
                                                 isSearchable={true}
                                                 isMulti={true}/>
                            {formErrors.team?.team_members &&
                                <ErrorDiv>{formErrors.team.team_members.message}</ErrorDiv>}
                        </div>
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <ModalCancelButton onClick={onClickCancel}>Cancel</ModalCancelButton>
                        <ModalSaveButton buttonDisabled={buttonDisabled}
                                         onClick={onClickSaveForm}>Save</ModalSaveButton>
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>Add Team Member</h3>
            {teamData.isLoading === false ? formContent() : <SpinnerDiv/>}
        </ModalContentWrapper>
    )
}

export default ModalAddTeamMember;

ModalAddTeamMember.defaultProps =
    {
        width: '600px',
        height: '600px'
    }

ModalAddTeamMember.propTypes = {
    team_id: PropTypes.string,
    filter: PropTypes.string,
    width: PropTypes.string,
};
